var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleDoorFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-10 0 1034 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1003 320q0 -9 -6.5 -15t-15.5 -6q-50 0 -97 10q-48 11 -91.5 30t-82.5 45q-40 26 -73 55q-39 35 -69.5 75t-49.5 81q-22 -72 -68 -123t-103 -85q-38 -22 -79 -38t-80.5 -26.5t-76.5 -15.5q-37 -6 -67 -8q-4 -1 -8.5 0.5t-7.5 5.5q-3 3 -5 7t-2 8v384q0 9 6.5 15t15.5 6 h938q9 0 15.5 -6t6.5 -15v-384v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDoorFill);
export default __webpack_public_path__ + "static/media/double-door-fill.979c9f54654d8e17d57d767d0aebe58c.svg";
export { ForwardRef as ReactComponent };